import React from "react";
import "./days-of-weeks.css";
const daysOfWeek = [
  {
    day: "0",
    label: "S",
  },
  {
    day: "1",
    label: "M",
  },
  {
    day: "2",
    label: "T",
  },
  {
    day: "3",
    label: "W",
  },
  {
    day: "4",
    label: "T",
  },
  {
    day: "5",
    label: "F",
  },
  {
    day: "6",
    label: "S",
  },
];

const DaysOfWeek = (props) => {
  const { workingDays } = props;
  const selectedDays = new Map(
    daysOfWeek.map(({ day }) => [day, workingDays.includes(day)]),
  );

  const isSelected = (day) => selectedDays.get(day);

  const isNextSelected = (day) =>
    !!selectedDays.get((+day + 1).toString());

  const isPrevSelected = (day) =>
    !!selectedDays.get((+day - 1).toString());

  return (
    <div className="days-of-week-container">
      {
        daysOfWeek.map(({ label, day }) => {
          return (
            <div
              key={day}
              className="day-of-the-week"
              style={{
                backgroundColor: isSelected(day) ? '#BABBC4' : 'transparent',
                color: isSelected(day) ? '#080912' : '#888992',
                borderTopLeftRadius: isPrevSelected(day) ? 0 : '36px',
                borderBottomLeftRadius: isPrevSelected(day) ? 0 : '36px',
                borderTopRightRadius: isNextSelected(day) ? 0 : '36px',
                borderBottomRightRadius: isNextSelected(day) ? 0 : '36px',
              }}
            >
              {label}
            </div>
          );
        })
      }
    </div>
  );
};

export default DaysOfWeek;
